import AboutUsHero from './hero';
import WhatWeDo from './whatWeDo';

const AboutUs = () => {
  return (
    <div>
      <div>
        <AboutUsHero />
        <WhatWeDo />
      </div>
    </div>
  );
};

export default AboutUs;
